import React, {Component} from "react";
import SecureLayout from "./../../../templates/secure";

class AxisSearch extends Component {
	render() {
		const { axis } = this.props;
		return <div className="field has-addons">
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._clearSearch}>
					&nbsp;&nbsp;
					<span className="icon is-small">
						<i className="fa fa-ban"/>
					</span>
				</a>
			</div>

			<div className="control">
				<input className="input is-small" type="search" ref="q" id="q" placeholder="Buscar" value={axis.filters.q} onChange={this._searchChange}/>
			</div>
			<div className="control">
				<a className="button is-inm-purple is-small" onClick={this._submitSearch}>Buscar</a>
			</div>
		</div>
	}

	constructor() {
		super();
		this._submitSearch = this._submitSearch.bind(this);
		this._searchChange = this._searchChange.bind(this);
		this._clearSearch = this._clearSearch.bind(this);
	}

	_submitSearch() {
		const {axis} = this.props;
		this.props.axisShow(1,axis.filters);
	}

	_searchChange(event){
		this.props.change('axis.filters.q',event.target.value);
	}

	_clearSearch(){
		this.props.reset('axis.filters');
		this.props.axisShow(1);
	}
}

export default SecureLayout(AxisSearch);



// WEBPACK FOOTER //
// ./src/elements/axis/widget/axis_search.jsx